<template>
    <div class="job-cards boxShadow transitionStyle">
        <div class="job-cards-detail " @click="gotoDetail(jobInfo.id)">
            <div class="flexBetween flexNowarp">
                <div class="flex tooltip-item">
                    <!-- <el-tooltip class="" 
                      effect="dark" 
                      :content="jobInfo.name" 
                      placement="bottom-start">
                        
                    </el-tooltip> -->
                    <p class="overText">{{jobInfo.name}}</p>
                    <img  
                       class="job-cards-detail-hot shrink" 
                       src="../../../assets/images/newicon/hot.png" 
                       alt="" />
                </div>
                <p class="job-cards-detail-salary shrink">{{jobInfo.salaryRangeName}}</p>
            </div>
            <div class="flex flexWarp">
                <Btn  v-if="jobInfo.parkName"   class="shrink" :value="jobInfo.parkName"/> 
                <Btn  v-if="jobInfo.workExperienceName"   class="shrink" :value="jobInfo.workExperienceName" />
                <Btn  v-if="jobInfo.qualificationsName"   class="shrink" :value="jobInfo.qualificationsName" />
            </div>
        </div>
        <div class="job-cards-company flexBetween itemsCenter">
            <div class="job-cards-company-name flex itemsCenter">
                <img :src="jobInfo.avatarUrl" class="shrink" />
                <el-tooltip 
                  class="item" 
                  effect="dark" 
                  :content="jobInfo.companyName" 
                  placement="bottom">
                    <p class="overText">{{jobInfo.companyName}}</p>
                </el-tooltip>
            </div>
            <p class="shrink">{{jobInfo.companyTypeName}}</p>
        </div>
    </div>
  </template>
  
  <script>
  import Btn from '../../../components/Btn.vue'
  export default {
    props: {
      jobInfo: {
        type: Object,
        default: () => {}
      },
      showStatus: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        
      };
    },
    components: {
        Btn
    },
    methods: {
        gotoDetail(id){
            window.open(`/job/detail?id=${id}`);
        },
    }
  };
  </script>
  
  <style lang="scss" scoped>
    $whiteColor:#fff;
    $fontCol:rgba(0,0,0,0.85);
    $secondfontCol:rgba(0,0,0,0.5);
    $yellowColor:#FF8A16;
.job-cards {
    border: 1px solid #E2E3EB;
    background-color: $whiteColor;
    width: 410px;
    margin-bottom: 24px;
    &:hover{
        box-shadow: 0 16px 40px 0 hsla(0, 0%, 60%, 0.3);
    }
    
    &:not(:nth-child(3n)){
        margin-right: 25px;
    }
    &-detail{
        padding: 28px 24px 14px;
        &-hot{
            width: 60px;
            height: 24px;
            margin-left: 10px;
            border-radius: 6px 0px 6px 0px;
            // background: linear-gradient(136deg, #FFAE22 0%, #FF760F 100%);;
        }
        &-salary{
            color: $yellowColor;
            font-size: 20px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            padding-left: 10px;
        }
        .flexWarp{
            .btn{
                margin-top: 10px;
            }
        }
        .flexNowarp{
           // margin-bottom: 8px;
            cursor: pointer;
            .tooltip-item{
                width: 70%;
                flex-wrap: nowrap;
                p{
                    font-size: 18px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: $fontCol;
                }
            }
        }
    }
    &-company{
        //background: #F9FBFC;
        border-top: 1px solid #EBEBEB;
        padding: 16px 24px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        border-radius: 0px 0px 6px 6px;
        flex-wrap: nowrap;
        p{
            color: $fontCol;
        }
        &-name{
            padding-right: 20px;
            cursor: pointer;
            img{
                width: 32px;
                height: 32px;
                background: #D8D8D8;
                border-radius: 2px;
                margin-right: 8px;
            }
            p{
                font-weight: 400;
                color: $secondfontCol;
            }
        }
    }
  }
  </style>
  